"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Layout_1 = __importDefault(require("./styles/Layout"));
var ReactionsFooter_1 = __importDefault(require("./styles/ReactionsFooter"));
var LikeReaction_1 = __importDefault(require("./components/LikeReaction"));
var Reactions = function (_a) {
    var controller = _a.controller, isPlaying = _a.isPlaying, reactionId = _a.reactionId, handleLikeReactionClick = _a.handleLikeReactionClick, campaign = _a.campaign, isEditPage = _a.isEditPage, handlePlayVideoClick = _a.handlePlayVideoClick;
    var handlePlayVideo = function (event) {
        var element = event.target;
        if (element.tagName !== "DIV" || element.id === "reactions-container")
            return;
        handlePlayVideoClick();
    };
    var handleFullscreenMode = function (event) {
        if (!isEditPage)
            controller === null || controller === void 0 ? void 0 : controller.handleFullscreenMode(event);
    };
    return (jsx_runtime_1.jsx(Layout_1.default, __assign({ isPlaying: isPlaying, onClick: handlePlayVideo, onDoubleClick: handleFullscreenMode }, { children: jsx_runtime_1.jsx(ReactionsFooter_1.default, { children: jsx_runtime_1.jsx(LikeReaction_1.default, { onClickReaction: handleLikeReactionClick, isActive: !!reactionId, backgroundColor: campaign.style.responseButtonBackground || campaign.style.background, onDoubleClick: controller === null || controller === void 0 ? void 0 : controller.preventFullscreen, isEditPage: isEditPage }, void 0) }, void 0) }), void 0));
};
exports.default = Reactions;
